import { IPrice } from './types';

export const formatPrice = ({ currency, value }: IPrice) => {
  let locale;

  switch (currency) {
    case 'EUR':
      locale = 'nl-NL';
      break;
    case 'USD':
      locale = 'en-US';
      break;
    case 'GBP':
      locale = 'en-US';
      break;
    default:
      locale = 'en-US';
      break;
  }

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(value);
};
